var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoan({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1501 1.66666H6.85008C3.70008 1.66666 2.91675 2.50832 2.91675 5.86666V15.25C2.91675 17.4667 4.13341 17.9917 5.60841 16.4083L5.61675 16.4C6.30008 15.675 7.34175 15.7333 7.93342 16.525L8.77508 17.65C9.45008 18.5417 10.5417 18.5417 11.2167 17.65L12.0584 16.525C12.6584 15.725 13.7001 15.6667 14.3834 16.4C15.8667 17.9833 17.0751 17.4583 17.0751 15.2417V5.86666C17.0834 2.50832 16.3001 1.66666 13.1501 1.66666ZM7.50008 5.83332C7.95842 5.83332 8.33342 6.20832 8.33342 6.66666C8.33342 7.12499 7.96675 7.49999 7.50008 7.49999C7.03341 7.49999 6.66675 7.12499 6.66675 6.66666C6.66675 6.20832 7.03341 5.83332 7.50008 5.83332ZM12.5001 11.6667C12.0334 11.6667 11.6667 11.2917 11.6667 10.8333C11.6667 10.375 12.0417 9.99999 12.5001 9.99999C12.9584 9.99999 13.3334 10.375 13.3334 10.8333C13.3334 11.2917 12.9667 11.6667 12.5001 11.6667ZM13.2501 6.32499L7.64175 11.9333C7.51675 12.0583 7.35842 12.1167 7.20008 12.1167C7.04175 12.1167 6.88341 12.0583 6.75841 11.9333C6.51675 11.6917 6.51675 11.2917 6.75841 11.05L12.3667 5.44166C12.6084 5.19999 13.0084 5.19999 13.2501 5.44166C13.4917 5.68332 13.4917 6.08332 13.2501 6.32499Z",
    fill: "#8B909A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoan);
export default __webpack_public_path__ + "static/media/Loan.88e993e5bef7c2a602b1dd5c4dbef1df.svg";
export { ForwardRef as ReactComponent };